import { createApi } from "@reduxjs/toolkit/query/react";

import {
  GroupComboResponse,
  SegmentComboResponse,
  SubgroupComboResponse,
} from "../models/product/productCombo.model";
import dynamicBaseQuery from "./dynamicBaseQuery";

export const productComboApi = createApi({
  reducerPath: "productComboApi",
  tagTypes: ["ProductCombo"],
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getSegmentsCombo: builder.query<SegmentComboResponse, void>({
      query: () => ({
        url: "/segmento/combo",
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
      providesTags: ["ProductCombo"],
    }),
    getGroupsCombo: builder.query<GroupComboResponse, void>({
      query: () => ({
        url: "/grupo/combo",
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
      providesTags: ["ProductCombo"],
    }),
    getSubgroupsCombo: builder.query<SubgroupComboResponse, void>({
      query: () => ({
        url: "/subgrupo/combo",
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
      providesTags: ["ProductCombo"],
    }),
  }),
});

export const {
  useGetSegmentsComboQuery,
  useGetGroupsComboQuery,
  useGetSubgroupsComboQuery,
} = productComboApi;
